export default {
  "home.heading.default": "hop on a call",
  "home.heading.loading": "Opening room...",
  "home.heading.join": "ready to join?",
  "home.heading.joined": "you’re in",
  "home.heading.pending": "waiting for the host",
  "home.body.default": "create a room, drop the link, vibe.",
  "home.body.loading": "one sec, grabbing the room.",
  "home.body.join": "check your cam and mic, then jump in.",
  "home.body.joined": "room’s live. share the link or just go.",
  "home.body.joined_in_room": "in the room — jump in or share the link.",
  "home.body.pending": "the room is locked. the host will let you in.",
  "home.cta.create": "Create room",
  "home.cta.join": "Join room",
  "home.cta.enter": "Enter room",
  "home.cta.creating": "Creating...",
  "home.cta.joining": "Joining...",
  "home.cta.opening": "Opening...",
  "home.cta.pending": "Waiting for approval...",
  "home.copy_link": "copy link",
  "home.copied": "copied!",
  "home.leave": "leave room",
  "home.back": "back",
  "home.no_participants": "no one here yet",
  "home.join_by_code": "join by invite code",
  "home.code_placeholder": "enter code",
  "home.name_placeholder": "your name",
  "home.people_one": "person",
  "home.people_other": "people",
  "home.marketing.invite.title": "Create a room,\nshare the link.",
  "home.marketing.invite.body": "One tap to start. Share the link with your friends and anyone can join — no downloads, no sign-ups.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Look how\nyou want.",
  "home.marketing.look.body": "Color grading, softening, vignette — or blur your face entirely. Your camera, your look.",
  "home.marketing.host.title": "Your space,\nyour rules.",
  "home.marketing.host.body": "Lock the room, mute someone, or remove them entirely. The host stays in control.",
  "home.marketing.host.locked": "Room locked",
  "home.marketing.host.waiting_to_join": "Waiting to join",
  "home.marketing.host.wants_to_join": "wants to join",
  "home.marketing.anything.title": "For anything, really.",
  "home.marketing.anything.body": "Study sessions, game nights, work standups, watching stuff together — or just hanging out.",
  "home.marketing.use_case.study_group": "📚 study group",
  "home.marketing.use_case.game_night": "🎮 game night",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ catch up",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 book club",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "call ended",
  "ended.left": "you left the room.",
  "ended.room_ended": "{title} has ended for you.",
  "ended.rejoin": "rejoin",
  "ended.rejoining": "rejoining...",
  "ended.home": "return home",
  "call.connecting": "connecting",
  "call.waiting": "waiting for others",
  "call.invite_code": "invite code",
  "call.audio_on": "audio on",
  "call.muted": "muted",
  "call.listening": "Listening",
  "call.audio_muted": "Audio muted",
  "call.speaking": "speaking",
  "call.you": "you",
  "call.you_label": "You",
  "call.you_suffix": "(you)",
  "call.chat_placeholder": "send a message...",
  "call.guest": "guest",
  "call.room_fallback": "room",
  "call.focus_view": "Focus view",
  "call.grid_view": "Grid view",
  "call.swap_main_video": "Swap main video",
  "call.open_chat": "Open chat",
  "call.close_chat": "Close chat",
  "call.leave_room": "Leave room",
  "call.confirm_leave": "Leave?",
  "call.mic_on": "Mic on",
  "call.muted_label": "Muted",
  "call.camera_off": "Camera off",
  "call.connect_failed": "Connection failed — check your internet and try again.",
  "call.camera_access_failed": "Couldn't access your camera. Check browser permissions and try again.",
  "call.recording_failed": "Recording couldn't start. The call will continue without it.",
  "call.initialize_failed": "Something went wrong starting the call. Please refresh and try again.",
  "call.participants": "Participants",
  "call.open_participants": "Open participants",
  "call.close_participants": "Close participants",
  "call.lock_room": "Lock room",
  "call.unlock_room": "Unlock room",
  "call.locked": "locked",
  "call.unlocked": "open",
  "call.kick_member": "Remove from room",
  "call.mute_member": "Mute",
  "call.unmute_member": "Unmute",
  "call.muted_by_host": "Muted by host",
  "call.waiting_to_join": "Waiting to join",
  "call.approve": "Approve",
  "call.deny": "Deny",
  "call.profile_actions": "Profile actions",
  "call.profile_in_room": "In room",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "You",
  "call.profile_action_mute": "Mute their audio",
  "call.profile_action_mute_meta": "Just for you — they won't know",
  "call.profile_action_dm": "1:1 DM",
  "call.profile_action_dm_meta": "Start a private side-chat",
  "call.profile_action_view": "View full profile",
  "call.profile_action_view_meta": "Bio, languages, past sessions",
  "call.profile_action_report": "Report",
  "call.profile_action_report_meta": "Flag for moderation review",
  "call.profile_sheet_close": "Close profile actions",
  "call.profile_open_actions": "Open profile actions",
  "call.dm_title": "Direct message",
  "call.dm_back": "Back to actions",
  "call.dm_close": "Close direct message",
  "call.dm_status_online": "Online",
  "call.dm_in_room_with": "In this room",
  "call.dm_private_label": "Private chat",
  "call.dm_private_meta": "Only the two of you can see these messages",
  "call.dm_input_placeholder": "Send a private message…",
  "call.dm_send": "Send",
  "call.dm_just_now": "now",
  "call.dm_seen_just_now": "Seen just now",
  "call.dm_typing": "{name} is typing…",
  "call.dm_minimize": "Minimize",
  "call.dm_active_indicator": "Open conversation",
  "call.dm_unread_messages": "{count} unread",
  "call.dm_toast_tap_to_open": "Tap to open",
  "call.dm_reopen_aria": "Reopen conversation with {name}",
  "home.join_denied": "The host didn't let you in.",
  "home.error.room_not_found": "That room code doesn’t exist.",
  "home.error.profile_required": "Set up your profile to continue.",
  "home.cta.set_up_profile": "Set up your profile",
  "home.profile_trigger_new": "Tap to add your details",
  "home.profile_trigger_new_aria": "Set up your profile",
  "home.profile_trigger_edit_aria": "Edit your profile",
  "profile.eyebrow_new": "say hi",
  "profile.eyebrow_edit": "your profile",
  "profile.title_new": "Make it yours.",
  "profile.title_edit": "Edit profile",
  "profile.subtitle": "A few quick details so partners know who they’re meeting.",
  "profile.add_photo": "Add photo",
  "profile.add_photo_soon": "photos coming soon",
  "profile.photo_empty": "tap to add a photo",
  "profile.photo_ready": "photo ready",
  "profile.photo_save_first": "save your profile before uploading a photo",
  "profile.photo_crop_caption": "frame your photo",
  "profile.photo_auto_caption": "drag and zoom, then we save it automatically",
  "profile.photo_upload": "Upload photo",
  "profile.photo_replace": "Replace photo",
  "profile.photo_remove": "Remove photo",
  "profile.photo_cancel": "Cancel",
  "profile.photo_save": "Save photo",
  "profile.photo_uploading": "Uploading photo…",
  "profile.photo_removing": "Removing photo…",
  "profile.photo_choose_another": "Choose another",
  "profile.photo_drag_hint": "Drag the photo to place it inside the circle. Changes save automatically.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Horizontal crop",
  "profile.photo_vertical": "Vertical crop",
  "profile.name_label": "Name",
  "profile.name_placeholder": "What should we call you?",
  "profile.gender_label": "I am",
  "profile.gender.woman": "Woman",
  "profile.gender.man": "Man",
  "profile.gender.unspecified": "Prefer not to say",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "optional",
  "profile.bio_placeholder": "Languages you speak, what you love, anything…",
  "profile.cta_new": "Let’s go",
  "profile.cta_edit": "Save changes",
  "profile.saving": "Saving…",
  "profile.close": "Close",
  "profile.error.save_failed": "Couldn’t save your profile. Try again.",
  "profile.error.avatar_invalid_type": "Choose a PNG, JPEG, GIF, or WebP image.",
  "profile.error.avatar_too_large": "Choose an image smaller than 5 MB.",
  "profile.error.avatar_too_small": "Choose an image that is at least 96 by 96 pixels.",
  "profile.error.avatar_load_failed": "We couldn’t read that image. Try another file.",
  "profile.error.avatar_failed": "Couldn’t upload your photo. Try again.",
  "profile.error.avatar_remove_failed": "Couldn’t remove your photo. Try again.",
  "effects.title": "Effects",
  "effects.soft": "Soft focus",
  "effects.vignette": "Vignette",
  "effects.face": "Face blur",
  "effects.face_preview_only": "Face blur (preview only)",
  "effects.face_viewer_side": "Face blur (viewer-side)",
  "effects.face_strength": "Face blur strength",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "WARM",
  "effects.grade.cool": "COOL",
  "effects.grade.bw": "B&W",
  "camera.off": "camera is off",
  "camera.check": "check your camera",
  "camera.retry": "retry camera",
  "camera.ready": "camera ready",
  "camera.idle.title": "Turn on your camera",
  "camera.idle.hint": "We’ll ask your browser for access when you’re ready.",
  "camera.idle.button": "Turn on camera",
  "camera.status.idle": "Waiting for you",
  "camera.status.off": "Camera is off",
  "camera.status.loading": "Requesting camera access...",
  "camera.status.denied": "Allow camera access in the browser, then try again.",
  "camera.status.error": "Camera preview failed. Try again.",
  "camera.status.unsupported": "This browser does not expose camera access.",
  "camera.status.insecure": "Camera access needs HTTPS or localhost.",
  "camera.status.attach_failed": "Camera preview could not start. Try again.",
  "camera.guest_name_placeholder": "Guest name",
  "camera.flip": "Switch camera",
  "camera.save_name": "Save",
  "camera.edit_name": "Edit name",
  "mic.on": "Turn microphone off",
  "mic.off": "Turn microphone on",
  "video.on": "Turn camera off",
  "video.off": "Turn camera on",
  "chat.title": "chat",
  "chat.close": "Close chat",
  "chat.loading": "loading...",
  "chat.load_earlier": "load earlier",
  "chat.empty": "no messages yet",
  "chat.send_error": "Message didn't send — try again.",
  "chat.input_placeholder": "type a message...",
  "room.host": "Host",
  "app.room_default_title": "Create a room",
  "app.chat_connection_rejected": "Chat couldn't connect — try refreshing.",
  "app.copy_failed": "Couldn't copy the link. Try selecting and copying it manually.",
  "app.chat_not_connected": "Chat isn't connected yet. Give it a moment and try again.",
  "footer.terms": "Terms & Conditions",
  "footer.copyright": "© 2026 Yano.AI",
}
